import App from '@/app'
import ErrorBoundaryView from '@components/error-boundary-view'
import { Analytics } from '@core/services/mixpanel'
import { GtmService } from '@core/services/gtm'
import { SentryService } from '@core/services/sentry'
import { ErrorBoundary } from '@sentry/react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

const renderApp = () => {
    const root = ReactDOM.createRoot(
        document.getElementById('asm') as HTMLElement
    )

    root.render(
        <ErrorBoundary
            fallback={<ErrorBoundaryView level="app" className="app" />}
        >
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </ErrorBoundary>
    )
}

const initialize = async () => {
    initializeMonitoring()
}

const initializeMonitoring = () => {
    Analytics.init()
    SentryService.init()
    GtmService.init()
}

initialize().then(renderApp)
